import { ReactElement, useEffect, useState } from "react";
import {
  Button,
  Text,
  Center,
  Modal,
  ModalContent,
  ModalBody,
  ModalOverlay,
  ModalFooter,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useModifiedTranslation } from "../../hooks/useModifiedTranslation";
import { useDefaultPath } from "../../hooks/useDefaultPath";

export function ErrorDialog(
  props: Readonly<{
    messageKey: string;
    onNavigate?: (defaultNavigate: () => void) => void;
  }>,
): ReactElement {
  const defaultPath = useDefaultPath();
  const navigate = useNavigate();
  const t = useModifiedTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (props.messageKey !== "") {
      setIsOpen(true);
    }
  }, [props.messageKey]);

  const defaultNavigate = (): void => {
    navigate(defaultPath, { replace: true });
  };

  const handleClick = (): void => {
    if (props.onNavigate) {
      props.onNavigate(defaultNavigate);
    } else {
      defaultNavigate();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={() => null}>
      <ModalOverlay />
      <ModalContent margin="auto" backgroundColor="common.base">
        <ModalBody>
          <Center flexDirection="column" mt={6}>
            <Text whiteSpace="pre-wrap" textAlign="center">
              {t(props.messageKey)}
            </Text>
          </Center>
        </ModalBody>
        <ModalFooter>
          <Button mx={6} flex={1} onClick={handleClick} variant="btn_primary">
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
